import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

function pad2(n) {
  return String(n).padStart(2, '0');
}

export function buildReembolsoReportFilename(techName = 'tecnico') {
  const now = new Date();
  const stamp = `${now.getFullYear()}${pad2(now.getMonth() + 1)}${pad2(now.getDate())}-${pad2(now.getHours())}${pad2(now.getMinutes())}`;
  const safe = String(techName || 'tecnico')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 40)
    .toLowerCase() || 'tecnico';
  return `reembolsos-${safe}-${stamp}.pdf`;
}

/**
 * Gera PDF a partir das folhas .gr-report-sheet já renderizadas (mesmo HTML do preview/impressão).
 */
export async function exportReembolsoReportPdf(sheetsRoot, filename) {
  if (!sheetsRoot) throw new Error('Pré-visualização do relatório indisponível.');
  const sheets = sheetsRoot.querySelectorAll('.gr-report-sheet');
  if (!sheets.length) throw new Error('Nenhuma página do relatório para exportar.');

  sheetsRoot.classList.add('is-exporting');

  try {
    await new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

    const pdf = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4', compress: true });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();

    for (let i = 0; i < sheets.length; i += 1) {
      if (i > 0) pdf.addPage('a4', 'landscape');
      const sheet = sheets[i];
      const canvas = await html2canvas(sheet, {
        backgroundColor: '#ffffff',
        scale: Math.min(2, Math.max(1.5, window.devicePixelRatio || 1)),
        useCORS: true,
        allowTaint: true,
        logging: false,
        scrollX: 0,
        scrollY: 0,
      });
      const imgData = canvas.toDataURL('image/jpeg', 0.93);
      pdf.addImage(imgData, 'JPEG', 0, 0, pageW, pageH, undefined, 'FAST');
    }

    pdf.save(filename || buildReembolsoReportFilename());
  } finally {
    sheetsRoot.classList.remove('is-exporting');
  }
}

export function printReembolsoReport() {
  window.print();
}
